import React, { type ComponentType, memo, useCallback } from 'react';
import MoreMenuCore from '@atlassian/jira-business-more-menu/src/ui/more-menu/more-menu-core/index.tsx';
import MoreMenuContent from './more-menu-content/index.tsx';
import type { Props } from './types.tsx';

const MoreMenu: ComponentType<Props> = memo(
	({ hideDoneItems, onChangeHideDoneItems, forceVisibility }: Props) => {
		const renderContent = useCallback(
			() => (
				<MoreMenuContent
					hideDoneItems={hideDoneItems}
					onChangeHideDoneItems={onChangeHideDoneItems}
				/>
			),
			[onChangeHideDoneItems, hideDoneItems],
		);
		return <MoreMenuCore renderContent={renderContent} forceVisibility={forceVisibility} />;
	},
);

export default MoreMenu;
